import type { Components } from "react-markdown";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

export const H6: Components["h6"] = ({ children, className, ...rest }) => (
  <h6
    className={cn("af-m-0 af-pt-6 af-text-xs af-font-bold", className)}
    {...rest}
  >
    {children}
  </h6>
);
